import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useAppContext } from '../../../redux/slices/appContext'
import { useCurrentClient } from '../../../redux/slices/clientContext'
import SydButton from '../../commonDesign/Button'
import { ICON_NAMES } from '../../../constants'
import { useRedtailClientLinkState } from './useRedtailClientLinkState'
import RedtailClientLinkDialog from './RedtailClientLinkDialog'

const useStyles = makeStyles({
  root: {
    minHeight: ({ minHeight }) => minHeight
  }
})

function NotLinkedInline ({ minHeight }) {
  const classes = useStyles({ minHeight })
  const { clientId } = useAppContext()
  const [, currentClient] = useCurrentClient()
  const state = useRedtailClientLinkState(clientId)
  const currentClientName = currentClient?.shortName || currentClient?.longName || null

  return (
    <>
      <div className={clsx(classes.root, 'flex flex-col items-center justify-center text-center gap-sm p-sm')}>
        <p className='font-size-sm my-0'>Link this client to Redtail</p>
        <SydButton
          size='sm'
          variant='primary'
          icon={ICON_NAMES.link}
          onClick={state.openDialog}
        >
          Link Redtail Contact
        </SydButton>
      </div>
      {state.isDialogOpen && (
        <RedtailClientLinkDialog
          open
          onClose={state.closeDialog}
          state={state}
          currentClientName={currentClientName}
        />
      )}
    </>
  )
}

NotLinkedInline.propTypes = {
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default NotLinkedInline
